<template>
  <div>
    <el-dialog
      title="Sync with Youtube Api Successful"
      :visible="show_sync_modal"
      width="500px"
      top="3vh"
      :modal="true"
      @close="closeDialog()"
    >
      <p><strong>UPDATED: {{sync_response.data.last_updated | datetime}}</strong></p>
      <p><strong>New Asset Labels From Api:</strong></p>
      <ul>
        <li v-for="label in sync_response.data.onYt" v-bind:key="label">
          {{label}}
        </li>
      </ul>
      <p><strong>Asset Labels Not on Api Anymore</strong></p>
      <ul class="last">
        <li v-for="label in sync_response.data.inDb" v-bind:key="label">
          {{label}}
        </li>
      </ul>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  data() {
    return {
      reason: '',
      showReasonError: false
    }
  },
  computed: {
    ...mapState('youtubeUsers', ['show_sync_modal', "sync_response"])
  },

  methods: {
    ...mapActions('youtubeUsers', []),
    ...mapMutations('youtubeUsers', ['setShowSyncModal']),

    closeDialog() {
      this.setShowSyncModal(false)
    }
  }
}
</script>
<style scoped>
  ul {padding-bottom: 10px}
  ul.last {padding-bottom: 40px}
</style>
